import { useEffect, useState } from 'react';

export const useGetPrizePost = posts => {
  const [prizePost, setPrizePost] = useState({});

  useEffect(() => {
    posts.map(post => {
      if (post.prize !== null) return setPrizePost(post);
      return null;
    });
  }, [posts]);

  return prizePost;
};
